export default "__VITE_ASSET__D$_vzD$7__"